module.exports = __webpack_public_path__ + "static/media/vet.0338eb05.svg";